import { Component, OnInit, OnDestroy, AfterViewInit  } from '@angular/core';
import { HomeComponent} from './home.component';
import { AuthenticationService } from '../_services/authentication.service';
import { DbService } from '../_services/db.service';


@Component({
  // tslint:disable-next-line:component-selector
    selector: 'homedesktop',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeDesktopComponent extends HomeComponent{

    constructor(authenticationService: AuthenticationService,
                service: DbService) {
        super(authenticationService, service);
    }

}
